<div class="container-shared-selection-table">
  <p class="h3 p-tb-12 border-bottom m-b-0">{{ tableTitle }}</p>

  <p class="m-t-4">
    {{ tableText }}
  </p>

  <table-pro [configs]="tableConfig">
    <table class="table-responsive table-md">
      <thead>
        <tr>
          <th>{{ 'accountSelection.select' | cxTranslate }}</th>

          <th *ngFor="let column of columns">
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredAndPaginatedItems" class="c-pointer" (click)="onSelectItem(item)">
          <td>
            <div class="form-group m-0 select-container">
              <label for class="m-0">
                <div class="form-check m-0">
                  <input
                    type="radio"
                    role="radio"
                    id="item-{{ item | json }}"
                    name="selectedItem"
                    class="form-check-input m-0"
                    aria-checked="true"
                    [value]="item | json"
                    [checked]="selectedItem?.uid === item.uid"
                    (change)="onSelectItem(item)"
                  />
                </div>
              </label>
            </div>
          </td>

          <td *ngFor="let column of columns" [attr.data-value]="item[column.key]">
            <span class="responsive-title"> {{ column.label }}: </span>

            {{ item[column.key] }}
          </td>
        </tr>
      </tbody>
    </table>
  </table-pro>
</div>

<!-- OLD -->

<!-- @if (from === '') {
	<input type="text" class="form-control m-t-20" placeholder="Search..." [(ngModel)]="searchTerm" />

	<select class="form-control d-lg-none mt-2" [(ngModel)]="sortValue" (ngModelChange)="onSortChange($event)">
		<option *ngFor="let option of sortOptions" [attr.aria-label]="option.label" [value]="option.value">
			{{ option.label }}
		</option>
	</select>

	<div class="container-table">
		<table class="table-responsive table-md m-t-20">
			<thead>
				<th>{{ 'accountSelection.select' | cxTranslate }}</th>

				<th *ngFor="let column of columns" (click)="sortTable(column.key)" class="filter">
					{{ column.label }}
					<span [ngClass]="getSortIcon(column.key) || 'fa fa-sort'" class="sort-icon"></span>
				</th>
			</thead>
			<tbody>
				<tr *ngFor="let item of filteredAndPaginatedItems" (click)="onSelectItem(item)" class="c-pointer">
					<td>
						<div class="form-group m-0 select-container">
							<label for class="m-0">
								<div class="form-check m-0">
									<input
										type="radio"
										role="radio"
										id="item-{{ item | json }}"
										name="selectedItem"
										class="form-check-input m-0"
										aria-checked="true"
										[value]="item | json"
										[checked]="selectedItem?.uid === item.uid"
										(change)="onSelectItem(item)"
									/>
								</div>
							</label>
						</div>
					</td>

					<td *ngFor="let column of columns">
						<span class="responsive-title">{{ column.label }}: </span>

						{{ item[column.key] }}
					</td>
				</tr>
			</tbody>
		</table>

		<div class="d-flex justify-content-between align-items-center">
			<div class="pagination-controls m-t-20 d-flex justify-content-center flex-grow-1" *ngIf="items.length! > pageSize">
				<button class="btn btn-outline-primary" (click)="goToPage(1)" [disabled]="currentPage === 1">
					<span class="material-symbols-outlined d-flex"> first_page </span>
				</button>

				<button class="btn btn-outline-primary" (click)="previousPage()" [disabled]="currentPage === 1">
					<span class="material-symbols-outlined d-flex"> chevron_backward </span>
				</button>

				<ng-container *ngFor="let page of getPages()">
					<button class="btn btn-outline-primary" (click)="goToPage(page)" [class.active]="page === currentPage">
						{{ page }}
					</button>
				</ng-container>

				<button class="btn btn-outline-primary" (click)="nextPage()" [disabled]="currentPage === totalPages">
					<span class="material-symbols-outlined d-flex"> chevron_forward </span>
				</button>

				<button class="btn btn-outline-primary" (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages">
					<span class="material-symbols-outlined d-flex"> last_page </span>
				</button>
			</div>
		</div>
	</div>
} -->
